import { MDText } from 'i18n-react';
import { isArray } from 'lodash';

import LocalTexts from 'Components/shared/SavedFilters/SavedFilters.texts.json';
import {
	getFirstValueAndRemainingCount,
	getSavedFilterValueTexts,
} from 'Stores/SavedFiltersStore/SavedFilters.helpers';
import useSavedFiltersDisplayOrder from 'Utilities/hooks/useSavedFiltersDisplayOrder';

const LocalT = new MDText(LocalTexts);

const ARRAY_VALUE_LIMIT = 3;

export const getValue = ({ delimiter, limitArrayValues, value }) => {
	const isValuesArray = isArray(value);

	if (!isValuesArray) {
		return value;
	}

	if (!limitArrayValues || value.length <= ARRAY_VALUE_LIMIT) {
		return value.join(delimiter);
	}

	return getFirstValueAndRemainingCount({ suffix: LocalT.translate('filterButtonTextSuffix'), values: value });
};

const useFormatSavedFilterValues = ({ delimiter = ', ', filterData = {}, limitArrayValues = false } = {}) => {
	const filtersDisplayConfig = useSavedFiltersDisplayOrder();
	const values = getSavedFilterValueTexts(filterData, filtersDisplayConfig);

	return values?.map(({ label, value }) => ({
		key: `savedFilterValue-${label}`,
		label,
		value: getValue({ delimiter, limitArrayValues, value }),
	}));
};

export default useFormatSavedFilterValues;
